import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Employee } from 'src/app/domain/organization/dto/Employee';
import { Subject } from 'rxjs';
import { ThreeDotsMenuEmployeeFields } from '../../shared/team-table/team-table.component';
import { OrganizationAccesses } from '../../service/organizations.service';
import { OrganizationWithAccesses } from '../../../../../core/component/hornavbar/dto/InitDataDTO';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
})
export class TeamComponent implements OnDestroy, OnChanges {
  private _destroyStream: Subject<void> = new Subject<void>();

  @Input() users: Employee[];
  @Input() selectedOrgWithAccesses: OrganizationWithAccesses;
  @Input() orgAccess: OrganizationAccesses;
  @Input() isAdmin = false;

  @Output() threeDotsClicked = new EventEmitter<ThreeDotsMenuEmployeeFields>();
  @Output() chosenEmployee = new EventEmitter<Employee>();

  noAccessTeam: Employee[];
  accessTeam: Employee[];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.users && this.users?.length) {
      this.separateByAccess();
    }
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  /**
   * Separate employees for two tables, based on accesses
   */
  private separateByAccess(): void {
    this.noAccessTeam = [];
    this.accessTeam = [];

    if (!this.selectedOrgWithAccesses.organization.hasAnyAccess()) {
      this.noAccessTeam.push(...this.users);
      return;
    }

    this.users.forEach((el) => {
      const employee = Employee.deserialize(el);
      const hasEmployeeNoAccess = employee.hasNoAccess();

      if (hasEmployeeNoAccess) {
        this.noAccessTeam.push(el);
      } else {
        this.accessTeam.push(el);
      }
    });
  }
}
